// import VueRouter, { RouteConfig } from 'vue-router'

const Layout = () => import('../views/Layout.vue')

export default [
  {
    path: '/resource',
    name: 'resource',
    component: Layout,
    meta: {
      title: '教学资源助手',
      icon: 'el-icon-folder-opened',
    },
    children: [],
  },
]
